exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[v-cloak][data-v-4873b2b0]{display:none}.anima-enter[data-v-4873b2b0]{opacity:0}.anima-enter-active[data-v-4873b2b0]{transition:opacity .2s;animation:slidein-data-v-4873b2b0 .2s ease-out forwards}.anima-leave-active[data-v-4873b2b0]{transition:opacity .2s;opacity:0;animation:slideout-data-v-4873b2b0 .2s ease-out forwards}@keyframes slidein-data-v-4873b2b0{0%{transform:translateY(-20px)}to{transform:translateY(0)}}@keyframes slideout-data-v-4873b2b0{0%{transform:translateY(0)}to{transform:translateY(20px)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4873b2b0","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 31
// module chunks = 0